export default __webpack_public_path__ + "static/media/stepper4.19238dab.png";